import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ServicesService } from '../../../services/services.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-services-mandays-summary',
  templateUrl: './services-mandays-summary.component.html',
  styleUrls: ['./services-mandays-summary.component.scss']
})
export class ServicesMandaysSummaryComponent implements OnInit {

    constructor(private _router: Router,
        private authentication: AuthenticationService,
        private common: CommonService,
        private servicesService: ServicesService) { }

    accountCredits = {
        balance: 0,
        consumed: 0,
        purchased: 0,
        reserved_for_Delivery: 0
    }


    ngOnInit(): void {
        this.getAccountCredits();
    }


    getAccountCredits() {

        this.servicesService.getAccountCredits(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success)
                    this.accountCredits = res.data;
                //console.log("getAccountCredits", res);
            },
            (err: any) => {
                console.error("err", err);
            }
        );
    }

}
